/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from "react"
import PropTypes from "prop-types"
import Header from "../header/header"
import { ToastContainer } from "react-toastify"
import "./layout.scss"
import ModalWrapper from "../../common/modal/modal-wrapper/modal-wrapper"

const Layout = ({ children }) => {
  let title = 'AFPA'
  if (process.env.GATSBY_USE_FHAA === 'true') {
    title = 'FHAA'
  }
  else {
    title = 'AFPA'
  }

  console.log("rendering Layout")

  return (
    <>
      {/* Every layout needs this to be able to display reusable modal windows (e.g. alertModal) */}
      <ModalWrapper />
      <Header siteTitle={title} />
      <main> {children} </main>
      <ToastContainer />
    </>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
